// UnsecuredDebtInformation.js
import React from 'react';
import './StepQuestionnaire.css';
import './login.css'
import './CreateFirm.css'
const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="trash-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
  </svg>
);

function UnsecuredDebtInformation({ debtType, debts, setDebts, labelPrefix }) {
  // Render the fields based on debtType.
  const renderDebtFields = (debt, index) => {
    switch (debtType) {
      case "creditCard":
      case "personalLoan":
      case "studentLoans":
        return (
          <>
            <input 
              type="text" 
              placeholder="Creditor" 
              value={debt.creditor || ""}
              onChange={(e) => updateDebt(index, "creditor", e.target.value)}
            />
            <input 
              type="text" 
              inputmode="numeric"
              placeholder="Debt Balance" 
              value={debt.debtBalance || ""}
              onChange={(e) => updateDebt(index, "debtBalance", e.target.value)}
            />
          </>
        );
      case "medical":
        return (
          <>
            <input 
              type="text" 
              placeholder="Creditor" 
              value={debt.creditor || ""}
              onChange={(e) => updateDebt(index, "creditor", e.target.value)}
            />
            <input 
              type="text" 
              inputmode="numeric"
              placeholder="Amount Owed" 
              value={debt.amountOwed || ""}
              onChange={(e) => updateDebt(index, "amountOwed", e.target.value)}
            />
          </>
        );
      case "backTaxes":
        return (
          <div className = 'vertical-stack-intake'>
            <select
              value={debt.taxType || ""}
              onChange={(e) => updateDebt(index, "taxType", e.target.value)}
            >
              <option value="">Select Tax Type</option>
              <option value="Federal">Federal</option>
              <option value="State">State</option>
            </select>
            {debt.taxType === "State" && (
              <input 
                type="text" 
                placeholder="State" 
                value={debt.state || ""}
                onChange={(e) => updateDebt(index, "state", e.target.value)}
              />
            )}
            <input 
              type="text" 
              inputmode="numeric"
              placeholder="Year" 
              value={debt.year || ""}
              onChange={(e) => updateDebt(index, "year", e.target.value)}
            />
            <input 
              type="text" 
              inputmode="numeric"
              placeholder="Amount" 
              value={debt.amount || ""}
              onChange={(e) => updateDebt(index, "amount", e.target.value)}
            />
          </div>
        );
      case "otherDebt":
        return (
          <>
            <input 
              type="text" 
              placeholder="Creditor" 
              value={debt.creditor || ""}
              onChange={(e) => updateDebt(index, "creditor", e.target.value)}
            />
            <input 
              type="text" 
              placeholder="Description" 
              value={debt.description || ""}
              onChange={(e) => updateDebt(index, "description", e.target.value)}
            />
            <input 
              type="text" 
              inputmode="numeric"
              placeholder="Amount Owed" 
              value={debt.amountOwed || ""}
              onChange={(e) => updateDebt(index, "amountOwed", e.target.value)}
            />
          </>
        );
      default:
        return null;
    }
  };

  const addDebt = () => {
    let newDebt = {};
    switch (debtType) {
      case "creditCard":
      case "personalLoan":
      case "studentLoans":
        newDebt = { creditor: "", debtBalance: "" };
        break;
      case "medical":
        newDebt = { creditor: "", amountOwed: "" };
        break;
      case "backTaxes":
        newDebt = { taxType: "", state: "", year: "", amount: "" };
        break;
      case "otherDebt":
        newDebt = { creditor: "", description: "", amountOwed: "" };
        break;
      default:
        break;
    }
    setDebts([...debts, newDebt]);
  };

  const updateDebt = (index, field, value) => {
    const newDebts = [...debts];
    newDebts[index][field] = value;
    setDebts(newDebts);
  };

  const deleteDebt = (index) => {
    const newDebts = debts.filter((_, i) => i !== index);
    setDebts(newDebts);
  };

  return (
    <div className="unsecured-debt-section">
      <h3>{labelPrefix} {debtType === "backTaxes" ? "Back Taxes" : debtType.charAt(0).toUpperCase() + debtType.slice(1)} Debt Information</h3>
      {debts.map((debt, idx) => (
        <div key={idx} className="debt-form">
          <div className="debt-header">
            <span>{labelPrefix} {debtType.charAt(0).toUpperCase() + debtType.slice(1)} Debt {idx + 1}</span>
            <button className="delete-button" onClick={() => deleteDebt(idx)}>
              <TrashIcon />
            </button>
          </div>
          <div className="debt-grid">
            {renderDebtFields(debt, idx)}
          </div>
        </div>
      ))}
      <button className="action-button" onClick={addDebt}>
        Add {debtType.charAt(0).toUpperCase() + debtType.slice(1)} Debt
      </button>
    </div>
  );
}

export default UnsecuredDebtInformation;